import React,{useState} from "react";
import {Link, Grid, Box, Hidden, Paper, Typography, Container, Checkbox, 
	TextField, FormControlLabel, CssBaseline, Button, Avatar, CircularProgress} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { makeStyles } from "@material-ui/core/styles";
import { useImmer } from "use-immer";
import {post} from "api";
import loader from "api/loader";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));

export default function SignIn() {
	const classes = useStyles();
	let history = useHistory();
	const [user, setUser] = useImmer({clave:"",correo:"",password:"",nombre:"",telefono:"", recomendacion:""});
	const [status, setStatus] = useState({status:"ready"});

	const handleLogin = (e) => {
		e.preventDefault();
		setStatus({status:"loading"});
		post("customer-register",user).then(r=>{
			
			loader.login(r.data.token);
			history.replace("/cursos");
		}).catch(e=>{

			console.log(e);
			setStatus({status:"error",message:e});
		});
		console.log(user);
	};
	return (
		<Grid container spacing={0}>
        
			{/* <Hidden smDown>
				<Grid item xs>
					<img src={require("assets/img/login.png")}
						alt="imagen principal"
						style={{ width: "100%",
							height: "100%",
							objectFit: "cover"}}
					/>
				</Grid>
			</Hidden> */}
			<Grid item md={6} sm={12}>
				<Container component="main" maxWidth="xs">
					<CssBaseline />
					<div className={classes.paper}>
						<img src={require("assets/img/logo/logo_nombre.png")}
							alt="imagen principal"
							style={{ 
								height: "130px",
								marginBottom:"30px",
								objectFit: "cover"}}
						/>
						<Typography color="primary" component="h1" variant="h5">
							REGISTRATE PARA COMENZAR A UTILIZAR NUTRIFY
						</Typography>
						<Typography style={{textAlign:"center"}} color="secondary">
							Recuerda que estos son los datos para acceder como nutriólogo y no a la App para pacientes.
						</Typography>
						<form className={classes.form} noValidate>
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								id="nombre"
								label="Nombre"
								name="nombre"
								autoComplete="name"
								autoFocus
								value={user.nombre}
								onChange={(e)=>{
									e.persist();
									setUser((draft)=>{draft.nombre = e.target.value;});
								}}
							/>
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								id="email"
								label="Correo"
								name="email"
								autoComplete="email"
								value={user.correo}
								onChange={(e)=>{
									e.persist();
									setUser((draft)=>{draft.correo = e.target.value;});
								}}
							/>
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								id="telefono"
								label="Teléfono"
								name="tel"
								autoComplete="tel"
								value={user.telefono}
								onChange={(e)=>{
									e.persist();
									setUser((draft)=>{draft.telefono = e.target.value;});
								}}
							/>
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								id="usuario"
								label="Crea tu código de nutriólogo"
								name="codigo"
								autoComplete="codigo"
								value={user.clave}
								onChange={(e)=>{
									e.persist();
									setUser((draft)=>{draft.clave = e.target.value;});
								}}
							/>
							
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								name="password"
								label="Contraseña"
								type="password"
								id="password"
								autoComplete="current-password"
								value={user.password}
								onChange={(e)=>{
									e.persist();

									let value = e.target.value;
									setUser((draft)=>{draft.password = value;});
								}}
							/>
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								name="recomendacion"
								label="Código de recomendación (opcional)"
								type="text"
								id="recomendacion"
								value={user.recomendacion}
								onChange={(e)=>{
									e.persist();

									let value = e.target.value;
									setUser((draft)=>{draft.recomendacion = value;});
								}}
							/>
							{status.status==="error" &&
                  <Alert severity="error">{JSON.stringify(status.message)}</Alert>
							}
							{status.status==="loading" ?
								<CircularProgress />
								:
								<Button
									type="submit"
									fullWidth
									variant="contained"
									color="primary"
									onClick={handleLogin}
								>
                    Registrarme
								</Button>
							}
                
                
							<Grid style={{marginTop:"17px"}} container>
								<Grid item xs>
									<Link href="/login" variant="body2">
                     ¿Ya tienes cuenta?
									</Link>
								</Grid>
								{/* <Grid item>
                    <Link href="#" variant="body2">
                      {"Don't have an account? Sign Up"}
                    </Link>
                  </Grid> */}
							</Grid>
						</form>
					</div>
				</Container>
			</Grid>
		</Grid>
     
    
	);
}